/**
 * DEMO SESSION PROVIDER
 * 
 * This provider provides demo user information for demonstration purposes.
 * It allows testing of localStorage persistence by emulating a user session.
 * 
 * Note: The logout functionality has been removed as it was only for demo purposes.
 */

import React, { createContext, useContext } from 'react';

interface DemoSessionContextType {
  userName: string;
  userInitials: string;
}

const DemoSessionContext = createContext<DemoSessionContextType | undefined>(undefined);

const DEMO_USER_NAME = 'Alice Johnson';
const DEMO_USER_INITIALS = 'AJ';

export function DemoSessionProvider({ children }: { children: React.ReactNode }) {
  return (
    <DemoSessionContext.Provider
      value={{
        userName: DEMO_USER_NAME,
        userInitials: DEMO_USER_INITIALS,
      }}
    >
      {children}
    </DemoSessionContext.Provider>
  );
}

export function useDemoSession() {
  const context = useContext(DemoSessionContext);
  if (context === undefined) {
    throw new Error('useDemoSession must be used within a DemoSessionProvider');
  }
  return context;
}
